import { EUR_EXCHANGE_RATE } from './constants/currencyRates';
import { roundPrice } from './roundPrice';

export function convertToBgn(price: number, decimalPlaces: number = 2): string {
  return roundPrice(price * EUR_EXCHANGE_RATE, decimalPlaces);
}
